<template>
  <div>
    <div class="style-browser">
      <div id="style-col" class="browse-col">
        <div class="h2">{{ $nippets.browseByStyle}} &nbsp;<span class="gr">/</span>&nbsp;
          <span class="lc">{{ $nippets.categories}}</span>&nbsp;
                    <span class="gr">/</span>&nbsp; <span class="lc">{{ $nippets.media }}</span>
        </div>
        <div class="four-col">
          <ix-router-link v-for="gal in gals" :key="gal.gallery_id" :to="gal.url" v-html="gal.name"></ix-router-link>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import StyleFetcher from '@/mixins/StyleFetcher.js'
export default {
  mixins: [StyleFetcher]
}
</script>
<style scoped>
  .four-col{
    columns:4;
    column-gap:40px;
  }

  .gr{
    color:#999;
  }



</style>

